import React, { Component } from 'react';
import * as serviceWorker from './serviceWorker';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { Provider } from 'react-redux';
import MomentUtils from '@date-io/moment';
import store from './store';
import MainLayout from './components/MainLayout';
import './App.css';
//import initFirebase from './firebase.init';
import { LanguageProvider } from './extensions/LangaugeContainer';

const style = {
  shadows: Array(25).fill('none'),
  typography: {
    useNextVariants: true,
    color: '#444'
  },
  palette: {
    primary: {
      main: '#00B0DE',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#B2E477',
      contrastText: '#FFFFFF'
    }
  }
}

export default class App extends Component {
  constructor(props) {
    super(props);
    serviceWorker.register.bind(this);
    serviceWorker.register({
      onUpdate: this.handleServiceWorkerUpdate
    });
  }

  componentDidMount(){
    //console.log("App mounted");
    localStorage.setItem("LoadLastVisited", true);
    //initFirebase();
    // navigator.serviceWorker.addEventListener("push", (payload) => {
    //   window.registration.showNotification("Hellloo");
    //   console.log("Message test:", payload);
    // })
  }

  state = {
    UpdateAvailable: false
  }

  handleServiceWorkerUpdate(registration) {
    this.setState({ UpdateAvailable: true })
  }

  ReloadPage = () => {
    window.location.reload();
  }

  render() {
    const theme = createMuiTheme(style);
    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <LanguageProvider>
          <React.Fragment>
            <CssBaseline />
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <div className='App'>
                <MainLayout />
              </div>
            </MuiPickersUtilsProvider>
          </React.Fragment>
          </LanguageProvider>
        </Provider>
      </MuiThemeProvider>
    );
  }
}
